import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uuidV4 from 'uuid/v4';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import UserAuthentication from 'user/UserAuthentication';
import GuestLogin from './GuestLogin';

export default class CheckoutUserAuthentication extends Component {
    static propTypes = {
        user: PropTypes.object,
        referralSource: PropTypes.string.isRequired,
        onUserChange: PropTypes.func.isRequired,
        focusGuestLogin: PropTypes.bool,
        focusUserAuthentication: PropTypes.bool
    };
    state = {
        prevUser: this.props.user,
        userAuthenticationKey: uuidV4()
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            user
        } = nextProps;

        if (user.status !== prevState.prevUser) {
            return {
                userAuthenticationKey: uuidV4(),
                prevUser: user
            };
        }

        return null;
    }

    render() {
        const {
            referralSource,
            onUserChange,
            focusGuestLogin,
            focusUserAuthentication
        } = this.props;
        const {
            userAuthenticationKey
        } = this.state;

        return (
            <div className="CheckoutUserAuthentication">
                <GuestLogin
                    focus={focusGuestLogin}
                    onUserChange={onUserChange}
                />
                <HorizontalRule lineStyle="solid">or</HorizontalRule>
                <UserAuthentication
                    ref={node => { this._checkoutUserAuthentication = node; }}
                    key={userAuthenticationKey}
                    referralSource={referralSource}
                    focus={focusUserAuthentication}
                    onUserChange={onUserChange}
                />
            </div>
        );
    }
}
